import { useEffect, useState } from "react"
import { APP_KEY_IDS } from "../../constants/constants"
import BaseNativeAppContainer from "../base-native-app-container/BaseNativeAppContainer"
import Styles from "./AboutMe.module.scss"

const AboutMe = () => {

    const [next,setNext]=useState(false)

    const [info, setInfo] = useState([ 
        "Hello World",
        "Welcome to my portfolio",
        "This is Priyansh Datyal",
        "DOB : Jun-2001",
        "Computer Science Engineer 2018-2022",
        "Professional Experience : 1yr 3months",
        "Origin : Himachal Pradesh",
    ])

    useEffect(()=>{
        setTimeout(()=>{
            setNext(true)
        },10000)
    })

    return (
        <BaseNativeAppContainer

            appId={APP_KEY_IDS.ABOUT_ME} title={"About"}
            loadFromX={10}
            lighTheme={true}
            MainScreen={
                <div className={Styles.container}>
                    <div className={Styles.base_command} id="cmd">
                        #!/bin/sh ~ about priyansh_datyal --all
                    </div>
                    <div className={Styles.info} id="info">
                        {
                            info.map((line:string,index:number) => {
                                return (
                                    <div style={{animationDelay:`${(index+1)*1000+500}ms`}} className={Styles.info_line} key={index}>{line}</div>
                                )
                            })

                        }
                    </div>
                    {
                        next && <div className={Styles.base_command} id="cmd">
                        #!/bin/sh ~
                    </div>
                    }
                </div>


            } height={500} width={725} />
    )
}

export default AboutMe
